module.exports = __webpack_public_path__ + "static/media/join.0f912976.png";